import { Component, OnInit, Input, ComponentFactoryResolver, ViewContainerRef } from '@angular/core';
import { NgbModalRef, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TourGuideService } from '../../_services/tour-guide.service';
import { environment } from '../../../environments/environment';
import { DomSanitizer } from '@angular/platform-browser';
import { InfoIconComponent } from '../../_directives/info-icon/info-icon.component';
import { UserService } from '../../_services/user.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-cira-help',
  templateUrl: './cira-help.component.html',
  styleUrls: ['./cira-help.component.scss']
})
export class CiraHelpComponent implements OnInit {
  private modalRef: NgbModalRef;
  helpdocStatus :boolean = false;
  docUrl: any ;
  openHelpDoc:any;
  componentRef: any;
  releaseVersion: any;
  // @Input() restrict: any=false;

  constructor(
    public tourGuideService: TourGuideService,
    private modalService: NgbModal,
    private sanitizer: DomSanitizer,
    private resolver: ComponentFactoryResolver,
    private container: ViewContainerRef,
    public _userService: UserService,
    public router: Router
    ) { 
      this.docUrl = this.sanitizer.bypassSecurityTrustResourceUrl(environment.doc_url + "/")
    }

  ngOnInit() {
    this.versionInfo()
  }

  openTourPopUp(){
    this.tourGuideService.showSearchPopup.emit(true);
  }
  openLink() {
    window.open('https://community.cognicor.com', '_blank');
  }

  openHelpInfo(){
    const factory = this.resolver.resolveComponentFactory(
      InfoIconComponent
  );
  this.componentRef = this.container.createComponent(factory);
  this.componentRef.instance.autoTrigger = true;

  }

  versionInfo(){
    this._userService.loadUserInfo().then(
      (result) => {
        this.releaseVersion = result["release_version"];
        console.log(this.releaseVersion)
      }),
      (error) => {
        console.log(error);
      }
  }
  
  onClickReleaseHistory(){
    this.router.navigateByUrl('/cira-release-history');
  }

}
